import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 24 12" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M16.8 0h-3.6v1.9h3.6c2.8 0 5 1.8 5 4.1s-2.2 4.1-5 4.1h-3.6V12h3.6c4 0 7.2-2.7 7.2-6s-3.2-6-7.2-6M2.3 6c0-2.3 2.1-4.1 4.9-4.1h3.6V0H7.2C3.2 0 0 2.7 0 6s3.2 6 7.2 6h3.6v-1.9H7.2c-2.8 0-5-1.8-5-4.1zm4.9 1h9.6V5H7.2z"
    }, null, -1)
  ]))]))
}
export default { render: render }